<template>
  <ReportColumnToggle query-property="show_notes">Notes</ReportColumnToggle>
</template>

<script>
export default {
  name: 'ReportShowNotesColumnToggle',
};
</script>
